import { render } from "./PageContent.vue?vue&type=template&id=0251dbe0"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"

import "./PageContent.vue?vue&type=style&index=0&id=0251dbe0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__